import { ff } from '@atlassian/jira-feature-flagging';

// </ssharma9>
export const isArchivedIssuesPageLinkEnabled = () => ff('enable-archived-issues-page-link', false);
// </ssharma9>

export const isIssueUnarchivalButtonEnabled = () => ff('issue-unarchival_wdpb9', false);
